import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { configureAmplify, resolveInitialAuthType } from './app/auth/amplify.config';

import { HttpClient, provideHttpClient, withFetch } from '@angular/common/http';
import { importProvidersFrom, APP_INITIALIZER } from '@angular/core';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';


configureAmplify(resolveInitialAuthType(localStorage.getItem('app_auth_type')));

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export function appInitializerFactory(translate: TranslateService) {
  return () => {
    translate.addLangs(['en', 'it']); 
    translate.setDefaultLang('it'); 
    return translate.use('it').toPromise();
  };
}

const mainAppProviders = [
  provideHttpClient(withFetch()), 
  importProvidersFrom(
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ),
  {
    provide: APP_INITIALIZER,
    useFactory: appInitializerFactory,
    deps: [TranslateService],
    multi: true
  },
  MessageService, 
  DialogService
];

const mergedAppConfig = {
  ...appConfig,
  providers: [...appConfig.providers, ...mainAppProviders]
};


bootstrapApplication(AppComponent, mergedAppConfig) 
  .catch((err) => console.error(err));
